<template>
  <details-view-layout v-if="resourceLoaded">
    <template v-slot:header>
      <span class="text-blue-500 border-solid border-l-2 border-gray-700 pl-2"> {{ pageTitle }}</span>
    </template>
    <template v-slot:preview>
      <preview-map :layer-id="id.toString()" />
    </template>
    <template v-slot:content>
      <resource-details :resource="resource" />
    </template>
    <template v-slot:side-bar>
      <div class="m-3 border-solid border-1 rounded">
        <div class="w-full p-2 uppercase text-lg bg-blue-100 text-blue-700">Available Downloads</div>
        <div :class="{ 'bg-gray-100': !isEven(index) }" v-for="(dist, index) in downloadDists" :key="index">
          <a class="hover:text-blue-500" :href="dist.accessURL" download="true">{{ dist.title }}</a>
        </div>
      </div>
      <div class="w-full p-3">
        <button
          v-if="!isOnExplorerMap"
          type="button"
          class="w-full rounded inline-block px-6 py-2.5 bg-blue-700 text-white font-medium text-sm leading-tight uppercase hover:bg-blue-600 disabled:bg-gray-500"
          @click="addToExplorerMap()"
        >
          <i class="fas fa-plus pr-2" /> Add to Map
        </button>
        <button
          v-else
          type="button"
          class="w-full rounded inline-block px-6 py-2.5 bg-blue-500 text-white font-medium text-sm leading-tight uppercase hover:bg-blue-600 disabled:bg-gray-500"
        >
          <router-link to="/Map">Go to Map<i class="fas fa-chevron-right pl-2" /></router-link>
        </button>
      </div>
    </template>
  </details-view-layout>
</template>

<script>
import DetailsViewLayout from '@/layouts/DetailsViewLayout'
import { useRoute, useRouter } from 'vue-router'
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue'
import ResourceDetails from '@/components/details-components/ResourceDetails'
import { useStore } from 'vuex'
import { ResourceSearchService } from '@/services/resource-search-service'
import { isEven } from '@/services/common/helpers'
import PreviewMap from '@/components/map-components/PreviewMap'

const resourceService = new ResourceSearchService()
export default {
  name: 'LayerDetails',
  components: { PreviewMap, ResourceDetails, DetailsViewLayout },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const id = route.params.id
    const pageTitle = ref('')
    const resource = ref(null)

    onBeforeMount(async () => {
      const result = await resourceService.Get(route.params.id)
      if (result.ok) {
        store.state.Details.resource = result.val
        resource.value = result.val
        pageTitle.value = result.val.identification.title
      } else {
        console.log(result.val)
      }
    })

    const downloadDists = computed(() => {
      const l = []
      const f = ['KML', 'CSV', 'GeoJSON', 'ZIP']
      if (store.state.Details.resource !== undefined) {
        store.state.Details.resource.distribution.forEach((dist) => {
          if (f.includes(dist.format)) {
            l.push(dist)
          }
        })
      }
      return l
    })

    function addToExplorerMap() {
      store.dispatch('Map/addLayer', store.state.Details.resource)
    }

    const isOnExplorerMap = computed(() => {
      const exists = store.state.Map.layers.find((x) => x.id === store.state.Details.resource.id)
      return exists !== undefined
    })

    const resourceLoaded = computed(() => {
      return resource.value !== null
    })

    onBeforeUnmount(() => {
      store.dispatch('DetailsMap/resetSelection')
      store.dispatch('Identify/close')
    })

    return { pageTitle, id, addToExplorerMap, isOnExplorerMap, resource, isEven, downloadDists, resourceLoaded }
  },
}
</script>

<style scoped>

</style>
